var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.912 16.1636C22.912 15.6531 22.8662 15.1622 22.7811 14.6909H16V17.476H19.8749C19.708 18.376 19.2007 19.1386 18.4382 19.6491V21.4556H20.7651C22.1265 20.2022 22.912 18.3564 22.912 16.1636Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 23.2C17.944 23.2 19.5738 22.5553 20.7651 21.4556L18.4382 19.6491C17.7934 20.0811 16.9687 20.3364 16 20.3364C14.1247 20.3364 12.5374 19.0698 11.9713 17.368H9.5658V19.2335C10.7505 21.5865 13.1854 23.2 16 23.2Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9713 17.368C11.8273 16.936 11.7455 16.4746 11.7455 16C11.7455 15.5255 11.8273 15.064 11.9713 14.632V12.7666H9.56587C9.07823 13.7386 8.80005 14.8382 8.80005 16C8.80005 17.1618 9.07823 18.2615 9.56587 19.2335L11.9713 17.368Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 11.6636C17.0571 11.6636 18.0062 12.0269 18.7523 12.7404L20.8174 10.6753C19.5705 9.51346 17.9407 8.8 16 8.8C13.1854 8.8 10.7505 10.4135 9.5658 12.7665L11.9713 14.632C12.5374 12.9302 14.1247 11.6636 16 11.6636Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.f1f5bc3ee6c8ed38d4e6ba84420226aa.svg";
export { ForwardRef as ReactComponent };